import React, { Component } from 'react';
import image from '../images/top-bar.png';
export default function TopBar() {

    return (
        <>
            <div className='top-bar px-3 pb-1 shadow-sm d-flex justify-content-end'>
                <img  src={image}></img>
            </div>
        </>

    )
}
